// TextBlock.js (or TextBlock.tsx)
import React from 'react';
import './TextBlock.css'
import Accordion from 'react-bootstrap/Accordion';
import "bootstrap/dist/css/bootstrap.min.css";
import Image from 'react-bootstrap/Image';

function TextBlock({block}) {
  // Implement your component logic here
  const contentStyle = {
    backgroundColor: block.backgroundColor,
    marginBottom: '16px'
  };
  return (
    <div style={contentStyle} className="text-block">
      {/* Render the header */}
      <h2 id={block.section} className='text-block-h2'>{block.header}</h2>

      <div  className={`text-block-content ${block.isImageOnRight ? 'image-on-right' : 'image-on-left'}`}>
        {/* Render the text */}

        {/* Render the image */}
        { block.image &&

        <div className="text-block-image">
          <img src={block.image} width="175px" alt={block.header} />
        </div>
        }
        <div className="text-block-text">
          <p className="text-block-text">{block.text}</p>
        </div>

      </div>
      <div>

      {block.dropdown &&  block.dropdown.map((item, index) => (
        <Accordion>

        <Accordion.Item eventKey={String(index)}>
        <Accordion.Header>{item.head}</Accordion.Header>
        <Accordion.Body>
        {item.text}
        {item.image && <Image src={item.image} fluid />}
        </Accordion.Body>
        </Accordion.Item>
        </Accordion>

          // <ExpandableText title={item.head} content={item.text}/> 
          ))}

          </div>
    </div>
  );
}

export default TextBlock;
